import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { RestoreStep } from '../../../../infrastructure/types/features/auth/auth-types';
import { RecoveryRequestForm } from '../RecoveryRequestForm';
import { RecoveryWaitEmail } from '../RecoveryWaitEmail';

interface RecoveryWrapperProps {}

let RecoveryWrapper = function ({}: RecoveryWrapperProps): ReactElement {
  const { authorizationUiModule } = useUILogic();
  const restoreUIManager = authorizationUiModule.restorePasswordUIManager;

  const renderStep = () => {
    switch (restoreUIManager.coreManager.step) {
      case RestoreStep.ENTER_EMAIL:
        return <RecoveryRequestForm />;
      case RestoreStep.WAIT_EMAIL:
        return <RecoveryWaitEmail />;
      default:
        return null;
    }
  };

  return <Wrapper>{renderStep()}</Wrapper>;
};

const Wrapper = styled.div``;

RecoveryWrapper = observer(RecoveryWrapper);

export { RecoveryWrapper };
